import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { withAuthCreateContainer } from "~/Containers/ContainerCreate";
import { postGetUserFavorites } from "~/api/getUser";
import { useUser } from "~/Context/userContext";
import Spinner from "react-bootstrap/Spinner";

const UserFavoritesContainer = (props) => {
  const { state: userState } = useUser();

  useEffect(() => {
    props.request(props.userDir, props.page);
  }, [props.page]);

  const { data, loading, failure, render } = props;
  const more = (data && data.data.more) || [];
  const tracks = (data && data.data.tracks) || [];

  if (!userState || !userState.loaded) {
    return <Spinner animation="border" variant="secondary" />;
  }

  return loading ? <Spinner animation="border" variant="secondary" /> : render({ tracks, more, loading, failure });
};

UserFavoritesContainer.propTypes = {
  page: PropTypes.number,
  userDir: PropTypes.string.isRequired,
};

export default withAuthCreateContainer(postGetUserFavorites, UserFavoritesContainer);
